import { useEffect, useMemo, useState } from 'react';
import { Menu } from 'antd';
import { useSelector } from 'react-redux';
import { LayoutDashboard } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import UtilObject from '../../utils/UtilObject';
import MyLink from '../../components/myLink/MyLink';
import useWindowSize from '../../hooks/useWindowSize';
import MyLucideIcon from '../../components/myIcon/MyLucideIcon';

const BlockedSideBarMenu = ({ onCloseToggle }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isMobile } = useWindowSize();

  const [selectedMenuKey, setSelectedMenuKey] = useState(location.pathname);

  const lang = useSelector((state) => {
    return state.lang;
  });

  useEffect(() => {
    setSelectedMenuKey(location.pathname);
  }, [location.pathname]);

  let svgSize = 20;

  const items = useMemo(() => {
    return [
      {
        key: `/${lang}/dashboard`,
        className: 'side_menu_item',
        label: (
          <MyLink path="/dashboard" state={UtilObject.EMPTY_OBJECT}>
            {t('WORD_DASHBOARD')}
          </MyLink>
        ),
        icon: <MyLucideIcon icon={LayoutDashboard} size={svgSize} />,
      },
      {
        type: 'divider',
      },
    ];
  }, [lang, svgSize, t]);

  return (
    <Menu
      className="main_menu"
      defaultSelectedKeys={['1']}
      items={items}
      selectedKeys={[selectedMenuKey]}
      onSelect={(menu) => {
        isMobile && onCloseToggle && onCloseToggle();
        setSelectedMenuKey(menu?.key);
      }}
    />
  );
};

export default BlockedSideBarMenu;
